module.exports = __webpack_public_path__ + "media/images/brands/logo_energiefranken_gross-a1028896426e0a42d34d558f30410d4e.svg";